<template>
  <div>
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/contractmaterials/item-list' }"
          >代码生成</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/contractmaterials/item-list' }"
          >物资合同</el-breadcrumb-item
        >

        <el-breadcrumb-item>
          <span>查看</span>
          <span class="ccui-curr-crumb ccui-ml-10">XXXX</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container-detail-body">
        <contractMaterials :dataInfo="contractMaterials"></contractMaterials>
        <contractMaterialsProtocol
          :dataInfo="contractMaterialsProtocol"
        ></contractMaterialsProtocol>
        <contractMaterialsChecklist
          :dataInfo="contractMaterialsChecklist"
        ></contractMaterialsChecklist>
        <finance :dataInfo="finance"></finance>
        <contractFiles :dataInfo="contractFiles"></contractFiles>
      </div>
    </div>
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import contractMaterials from "./contractMaterials";
import contractMaterialsProtocol from "./contractMaterialsProtocol";
import contractMaterialsChecklist from "./contractMaterialsChecklist";
import finance from "./finance";
import contractFiles from "./contractFiles";

import { postGetDetail } from "../../api/item-list";
export default {
  name: "detailContractMaterials",
  components: {
    contractMaterials,
    contractMaterialsProtocol,
    contractMaterialsChecklist,
    finance,
    contractFiles
  },
  data() {
    return {
      focus: "contractMaterials",
      contractMaterials: {},
      contractMaterialsProtocol: [],
      contractMaterialsChecklist: [],
      finance: {},
      contractFiles: []
    };
  },
  created() {
    const arr = [this.$route.params.id];
    postGetDetail({ ids: arr }).then(data => {
      this.contractMaterials = data.data.data.contractMaterials;
      this.contractMaterialsProtocol = data.data.data.contractMaterialsProtocol;
      this.contractMaterialsChecklist =
        data.data.data.contractMaterialsChecklist;
      this.finance = data.data.data.finance;
      this.contractFiles = data.data.data.contractFiles;
    });
  },
  methods: {
    resetHandle() {},
    submitHandle() {},
    handleBack() {
      this.$router.push("/example-auto/contractmaterials/item-list");
    }
  }
};
</script>
